import React from "react";
import { Box, Text, HStack, VStack, BoxProps } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { FaCheckCircle } from "react-icons/fa";

export interface InfoSectionProps extends BoxProps {
  title: string;
  description?: string;
  rightIcon?: React.ReactNode;
  isCompleted?: boolean;
  onClick?: () => void;
  isClickable?: boolean;
}

const InfoSection: React.FC<InfoSectionProps> = ({
  title,
  description,
  rightIcon,
  isCompleted = false,
  onClick,
  isClickable = false,
  ...boxProps
}) => {
  const handleClick = () => {
    if (isClickable && onClick) {
      onClick();
    }
  };

  return (
    <Box
      borderRadius="lg"
      cursor={isClickable ? "pointer" : "default"}
      _hover={isClickable ? { backgroundColor: "gray.100" } : {}}
      transition="background-color 0.2s"
      onClick={handleClick}
      w="full"
      {...boxProps}
    >
      <HStack w="full" justifyContent="space-between" alignItems="flex-start">
        <HStack flex={1} gap={2} justifyContent="center" w="full">
          <Box
            flexShrink={0}
            mt={1}
            h="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <FaCheckCircle
              size={20}
              color={isCompleted ? "#38A169" : "#CBD5E0"}
            />
          </Box>
          <VStack flex={1} alignItems="flex-start" spacing={0}>
            <Text
              fontWeight="bold"
              fontSize="xl"
              color="gray.800"
              textAlign="left"
            >
              {title}
            </Text>
            {description && (
              <Text
                fontSize="sm"
                color="gray.600"
                textAlign="left"
                lineHeight="1.4"
              >
                {description}
              </Text>
            )}
          </VStack>
        </HStack>
        {rightIcon && (
          <Box flexShrink={0} mt={1}>
            {rightIcon}
          </Box>
        )}
      </HStack>
    </Box>
  );
};

export default InfoSection;
